<template>
  <svg
    id="Layer_1"
    data-name="Layer 1"
    xmlns="http://www.w3.org/2000/svg"
    :width="widthPX"
    :height="heightPX"
    viewBox="0 0 192 192"
  >
    <path
      d="M66.56,0h58.88C179.2,0,192,12.8,192,66.56v58.88C192,179.2,179.2,192,125.44,192H66.56C12.8,192,0,179.2,0,125.44V66.56C0,12.8,12.8,0,66.56,0Zm90.67,66.15c.89-3,0-5.15-4.23-5.15H139a6,6,0,0,0-6.09,4s-7.12,17.35-17.21,28.63c-3.26,3.26-4.74,4.3-6.52,4.3-.89,0-2.18-1-2.18-4V66.15c0-3.56-1-5.15-4-5.15H81a3.37,3.37,0,0,0-3.56,3.22c0,3.37,5,4.15,5.56,13.64V98.48c0,4.52-.82,5.34-2.6,5.34-4.74,0-16.29-17.43-23.13-37.38C55.92,62.57,54.58,61,51,61H37c-4,0-4.8,1.88-4.8,4,0,3.71,4.75,22.1,22.1,46.42C65.87,128,82.17,137,97,137c8.9,0,10-2,10-5.45V119c0-4,.84-4.8,3.66-4.8,2.08,0,5.64,1,13.94,9C134.1,132.74,135.66,137,141,137h14c4,0,6-2,4.85-5.95s-5.8-9.64-11.81-16.4c-3.27-3.86-8.16-8-9.64-10.09-2.08-2.67-1.49-3.86,0-6.23,0,0,17-24,18.83-32.18Z"
      transform="translate(0 0)"
      :fill="colorComputed"
    />
  </svg>
  <!--  <svg-->
  <!--    viewBox="0 0 512 512"-->
  <!--    y="0px"-->
  <!--    x="0px"-->
  <!--    version="1.1"-->
  <!--    :style="{ height: heightPX, width: widthPX }"-->
  <!--    :fill="colorComputed"-->
  <!--  >-->
  <!--    <g id="g6">-->
  <!--      <g id="g4">-->
  <!--        <path-->
  <!--          id="path2"-->
  <!--          d="M434.79,342.767l-5.074-8.289c-9.916-16.197-21.918-31.049-35.67-44.145l-16.965-16.154    c-1.612-1.536-1.854-3.974-0.575-5.797l23.164-33.008c3.341-4.76,6.423-9.773,9.163-14.899l19.794-37.037    c3.45-6.454,3.266-14.057-0.494-20.337c-3.758-6.279-10.373-10.034-17.691-10.042l-42.845-0.049c-0.009,0-0.017,0-0.026,0    c-8.976,0-17.105,5.309-20.712,13.529l-4.538,10.34c-11.578,26.381-27.382,50.435-46.988,71.525v-75.487    c0-10.982-8.935-19.917-19.916-19.917h-60.681c-9.964,0-18.069,8.106-18.069,18.07c0,3.805,1.173,7.45,3.391,10.538l4.246,5.915    c4.163,5.797,6.363,12.634,6.363,19.772v55.159c-7.483-8.691-16.594-20.493-24.307-34.062    c-11.811-20.78-20.277-45.011-24.272-57.606C158.713,160.148,148.949,153,137.79,153H94.396c-6.124,0-11.756,2.8-15.456,7.682    c-3.697,4.883-4.866,11.065-3.205,16.962l8.095,28.73c4.961,17.611,11.781,34.755,20.27,50.957    c2.562,4.891,8.604,6.78,13.498,4.217c4.893-2.563,6.78-8.607,4.217-13.499c-7.845-14.975-14.148-30.821-18.734-47.098L95.206,173    h42.585c2.403,0,4.506,1.54,5.233,3.833c4.233,13.343,13.233,39.07,25.95,61.441c10.434,18.356,23.093,33.648,31.877,43.244    c4.812,5.257,12.216,6.988,18.862,4.404c6.654-2.585,10.954-8.868,10.954-16.005v-62.622c0-11.349-3.499-22.22-10.116-31.437    L218.498,173h56.835v80.195c0,5.867,2.946,11.262,7.881,14.434c4.934,3.173,11.065,3.612,16.403,1.175l4.123-1.882    c1.9-0.866,3.587-2.075,5.018-3.594c21.702-23.046,39.156-49.428,51.878-78.413l4.538-10.34c0.417-0.952,1.358-1.566,2.397-1.566    h0.003l42.845,0.049c0.146,0,0.367,0.001,0.555,0.315c0.189,0.315,0.084,0.509,0.016,0.638l-19.794,37.036    c-2.361,4.417-5.018,8.736-7.896,12.838l-23.164,33.008c-7.012,9.992-5.685,23.353,3.154,31.77l16.964,16.154    c12.494,11.897,23.397,25.391,32.406,40.104l5.074,8.289c0.122,0.199,0.493,0.806,0.031,1.631    c-0.462,0.825-1.174,0.825-1.407,0.825h-36.989c-4.753,0-9.379-1.954-12.692-5.361l-36.986-38.03    c-8.716-8.962-19.777-15.117-31.988-17.797c-5.473-1.203-11.123,0.122-15.493,3.637s-6.876,8.746-6.876,14.353v37.366    c0,3.216-2.616,5.833-5.833,5.833c-28.662,0-56.985-9.59-79.752-27.003c-9.172-7.015-17.92-14.752-26.001-22.994    c-3.866-3.942-10.197-4.007-14.142-0.14c-3.944,3.867-4.006,10.199-0.14,14.142c8.743,8.918,18.208,17.288,28.132,24.878    c26.235,20.066,58.873,31.117,91.902,31.117c14.244,0,25.833-11.589,25.833-25.833V314.48c7.615,2.033,14.502,6.066,20.02,11.74    l36.986,38.03c7.056,7.255,16.908,11.417,27.03,11.417h36.989c7.813,0,15.038-4.234,18.855-11.05    C439.031,357.802,438.869,349.429,434.79,342.767z"-->
  <!--        />-->
  <!--      </g>-->
  <!--    </g>-->
  <!--    <g id="g12">-->
  <!--      <g id="g10">-->
  <!--        <path-->
  <!--          id="path8"-->
  <!--          d="M140.056,277.553l-0.111-0.155c-3.219-4.488-9.465-5.519-13.954-2.3c-4.488,3.219-5.518,9.466-2.3,13.954    c0.004,0.007,0.064,0.09,0.068,0.096l8.17-5.768l-8.127,5.827c1.953,2.724,5.022,4.174,8.136,4.174    c2.016,0,4.053-0.609,5.818-1.874C142.244,288.288,143.274,282.041,140.056,277.553z"-->
  <!--        />-->
  <!--      </g>-->
  <!--    </g>-->

  <!--    <g id="g30">-->
  <!--      <g id="g28">-->
  <!--        <path-->
  <!--          id="path26"-->
  <!--          d="M446,0H66C29.607,0,0,29.607,0,66v380c0,36.393,29.607,66,66,66h380c36.393,0,66-29.607,66-66V66    C512,29.607,482.393,0,446,0z M492,446c0,25.364-20.636,46-46,46H66c-25.364,0-46-20.636-46-46V66c0-25.364,20.636-46,46-46h380    c25.364,0,46,20.636,46,46V446z"-->
  <!--        />-->
  <!--      </g>-->
  <!--    </g>-->
  <!--  </svg>-->
</template>

<script>
export default {
  name: 'IconVk',
  props: {
    height: { type: Number, default: 24 },
    width: { type: Number, default: 24 },
    color: { type: String, default: '#FFFFFF' }
  },
  computed: {
    heightPX() {
      return `${this.height}px`;
    },
    widthPX() {
      return `${this.width}px`;
    },
    colorComputed() {
      return this.color;
    }
  }
};
</script>

<style lang="scss">
.icon {
  margin: 0 4px;
}
</style>
